export type BackpackChip = { text: string; belongsInPrompt: boolean; conceptId: string };
export type BackpackRound = { goal: string; chips: BackpackChip[] };

const OPS = "act_obligations_ops";
const ROLES = "act_scope_roles";
const GPAI = "gpai_transparency";
const MLOPS = "mlops_lifecycle";

export const EPSO_AD8_AI_BACKPACK_DECK: readonly BackpackRound[] = [
  {
    goal: "Article 27 FRIA contents the public deployer must assess (not extras that are someone else’s job).",
    chips: [
      {
        text: "The process and intended purpose of the use",
        belongsInPrompt: true,
        conceptId: OPS,
      },
      { text: "Period and frequency of use", belongsInPrompt: true, conceptId: OPS },
      {
        text: "Affected persons or groups and specific fundamental-rights risks",
        belongsInPrompt: true,
        conceptId: OPS,
      },
      {
        text: "Human-oversight measures and what happens if risks materialise",
        belongsInPrompt: true,
        conceptId: OPS,
      },
      { text: "The CE mark drawing itself", belongsInPrompt: false, conceptId: OPS },
      { text: "The 10^25 FLOP presumption for GPAI", belongsInPrompt: false, conceptId: GPAI },
    ],
  },
  {
    goal: "Provider duties for a high-risk system (Article 16 / Section 2) — not deployer-only tasks.",
    chips: [
      { text: "Quality management system", belongsInPrompt: true, conceptId: ROLES },
      {
        text: "Technical documentation and EU declaration of conformity",
        belongsInPrompt: true,
        conceptId: ROLES,
      },
      {
        text: "Relevant conformity assessment before placing on the market",
        belongsInPrompt: true,
        conceptId: ROLES,
      },
      {
        text: "Inform workplace staff that they will be subject to the system",
        belongsInPrompt: false,
        conceptId: OPS,
      },
      {
        text: "Keep deployer-controlled logs for at least six months",
        belongsInPrompt: false,
        conceptId: OPS,
      },
    ],
  },
  {
    goal: "What Article 12 logging is for on a high-risk system.",
    chips: [
      {
        text: "Spot situations that may present an Article 79 risk or a substantial modification",
        belongsInPrompt: true,
        conceptId: OPS,
      },
      { text: "Support post-market monitoring", belongsInPrompt: true, conceptId: OPS },
      {
        text: "Support the deployer’s operational monitoring",
        belongsInPrompt: true,
        conceptId: OPS,
      },
      {
        text: "Store every training row forever in a public wiki",
        belongsInPrompt: false,
        conceptId: OPS,
      },
    ],
  },
  {
    goal: "When Article 25 treats another party as the provider of a high-risk system.",
    chips: [
      {
        text: "They put their name or trademark on the system",
        belongsInPrompt: true,
        conceptId: ROLES,
      },
      {
        text: "They make a substantial modification that stays high-risk",
        belongsInPrompt: true,
        conceptId: ROLES,
      },
      {
        text: "They change intended purpose so a non-high-risk system becomes high-risk",
        belongsInPrompt: true,
        conceptId: ROLES,
      },
      {
        text: "They use the system in a purely personal non-professional activity",
        belongsInPrompt: false,
        conceptId: ROLES,
      },
      {
        text: "They sit on the European Artificial Intelligence Board",
        belongsInPrompt: false,
        conceptId: ROLES,
      },
    ],
  },
  {
    goal: "Article 53 duties for every GPAI model provider (not the Article 55 extras).",
    chips: [
      {
        text: "Keep technical documentation (Annex XI) for the Office and NCAs",
        belongsInPrompt: true,
        conceptId: GPAI,
      },
      {
        text: "Give downstream providers enough to understand limits (Annex XII)",
        belongsInPrompt: true,
        conceptId: GPAI,
      },
      {
        text: "A copyright policy including CDSM reservations",
        belongsInPrompt: true,
        conceptId: GPAI,
      },
      {
        text: "A public training-content summary on the Office template",
        belongsInPrompt: true,
        conceptId: GPAI,
      },
      {
        text: "Adversarial testing documented for systemic-risk models only",
        belongsInPrompt: false,
        conceptId: GPAI,
      },
    ],
  },
  {
    goal: "Signals a production monitor should catch after go-live (not train-time leakage).",
    chips: [
      {
        text: "Input distribution shift versus the live baseline",
        belongsInPrompt: true,
        conceptId: MLOPS,
      },
      {
        text: "Sudden collapse in recall or calibration on fresh labels",
        belongsInPrompt: true,
        conceptId: MLOPS,
      },
      {
        text: "Latency or error-rate spikes on the serving path",
        belongsInPrompt: true,
        conceptId: MLOPS,
      },
      {
        text: "A label that was already in a training feature (leakage at fit time)",
        belongsInPrompt: false,
        conceptId: MLOPS,
      },
    ],
  },
];
